import { graphql } from '@web/graphql-queries/index'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { Comments, type Comments as CommentsProps } from '@web/graphql-components'
import { CommentsQuery } from '@web/graphql-queries/graphql'
import { CommentProps } from '@web/components/page-components/Comments/Comment'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

export const commentsDocument = graphql(`
  query Comments($query: CommentsQueryInput!) {
    comments(query: $query) {
      comments {
        id
        message
        amount
        donatedBy
        donatedAt
        donatedTo {
          name
          slug
        }
        matchedAmount
        matchedDonationAmount
        dedicateeName
        organisationName
      }
      totalRecords
    }
  }
`)

export const getCommentsQueryOptions = (props: CommentsProps) => {
  const pageState = usePageStore.getState()
  const charityId = pageState.charityId
  const campaignId = pageState.campaignId
  const isLiveMode = pageState.isLiveMode
  const pageId = pageState.pageId
  const profileId = pageState.profileId
  const includeMatchedAmount = props.styles?.options?.includeMatchedAmount
  const hasFundraiserSupported = props.styles?.options?.hasFundraiserSupported
  const onlyDedicatedComments = props.styles?.options?.onlyDedicatedComments
  const options = {
    charityId,
    campaignId,
    isLiveMode,
    includeMatchedAmount,
    hasFundraiserSupported,
    onlyDedicatedComments,
  }

  const getPagesToQuery = () => {
    if (profileId) {
      return { ...options, profileId } // should link to profile
    }

    if (props.isAllPagesLinked) {
      return {}
    }

    if (props.linkedPageIds && props.linkedPageIds.length > 1) {
      return { pageIds: props.linkedPageIds }
    }

    return { pageId }
  }

  return { ...options, ...getPagesToQuery() }
}

dayjs.extend(relativeTime)

export const mapComment = (
  c: CommentsQuery['comments']['comments'][0],
  props: Comments,
  campaignDomain: string,
): CommentProps => ({
  ...c,
  message: c.message ?? '',
  donatedAt: dayjs().to(dayjs(c.donatedAt)),
  showAmount: props.showAmount,
  showMessage: props.showMessage,
  donatedTo: c.donatedTo ? { name: c.donatedTo.name, url: `${campaignDomain}/${c.donatedTo.slug}` } : undefined,
  matchedAmount: 0,
  matchedDonationAmount: 0,
  dedicateeName: c.dedicateeName ?? '',
  organisationName: c.organisationName ?? '',
})
